/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-children-prop */
/* eslint-disable import/no-extraneous-dependencies */
import { FC, useEffect, useState } from 'react';

import { Typography } from '~/common/components/Typography';

interface IMessageRendererProps {
  onFinish: () => void;
  onType: () => void;
  content: string;
  typingSpeed?: number; // opcional: tempo entre "digitação" de cada caractere
}

export const MessageRenderer: FC<IMessageRendererProps> = ({
  content = '',
  typingSpeed = 1,
  onFinish,
  onType,
}) => {
  const [displayedContent, setDisplayedContent] = useState('');

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      const setting = content.slice(0, currentIndex);
      if (setting.length === content.length && content.length > 0) {
        onFinish();
      }

      setDisplayedContent(setting);
      onType();
      currentIndex++;
      if (currentIndex > content.length) {
        clearInterval(interval);
      }
    }, typingSpeed);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, typingSpeed]);

  return (
    <Typography.Paragraph
      size="medium"
      color="neutral.200"
      style={{ whiteSpace: 'pre-line' }}
    >
      {displayedContent}
    </Typography.Paragraph>
  );
};
